class ConfiguratorDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#ConfiguratorDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.container = this.querySelector('.drawer__inner');

      const configuratorOptionsElement = document.querySelector('script#configurator-options');
      const glassesLenseVariantsElement = document.querySelector('script#glasses-lense-variants');
      const extrasPricesElement = document.querySelector('script#extras-prices');
      if (!configuratorOptionsElement) throw new Error('CONFIGURATOR OPTIONS MISSING');


      const configuratorOptions = JSON.parse(configuratorOptionsElement.textContent);
      const glassesLenseVariants = JSON.parse(glassesLenseVariantsElement.textContent);
      const extrasPrices = JSON.parse(extrasPricesElement.textContent);

      // available configurable options according to the config set in the metaobjects
      this.optionConfig = {
        focus: configuratorOptions.filter(({step}) => step === 'focus'),
        thickness: configuratorOptions.filter(({step}) => step === 'thickness'),
        quality: configuratorOptions.filter(({step}) => step === 'quality'),
        extras: configuratorOptions.filter(({step}) => step === 'extras'),
      };

      this.lenseVariants = glassesLenseVariants.variants;
      this.extrasPrices = extrasPrices;

      // to reuse html instead of fetching it again
      this.html = {};

      // container for items to be bundled upon adding to cart
      this.bundle = {};

      // container for appointment data in case of an appointment
      this.appointment = {};
  
      // if customer has already started the configurator and logged into the account in the middle of the process, proceed from the point where they left off
      if (sessionStorage.glassesBundle) this.proceed();
    }
  
    start(productForm) {
      fetch('?sections=configurator-focus')
        .then((response) => response.json())
        .then((response) => {
          this.html.focus = response['configurator-focus'];
          this.renderContents(this.html.focus);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          productForm.submitButton.classList.remove('loading');
          if (!productForm.error) productForm.submitButton.removeAttribute('aria-disabled');
          productForm.querySelector('.loading__spinner').classList.add('hidden');
        });
    }
  
    proceed() {
      this.bundle = JSON.parse(sessionStorage.glassesBundle);
  
      fetch('?sections=configurator-form')
        .then((response) => response.json())
        .then((response) => {
          this.renderContents(response['configurator-form']);
          sessionStorage.removeItem('glassesBundle');
        })
        .catch((e) => {
          console.error(e);
        });
    }
  
    open() {
      setTimeout(() => {
        this.classList.add('animate', 'active');
      });
  
      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = document.getElementById('ConfiguratorDrawer');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true }
      );
  
      document.body.classList.add('overflow-hidden');
    }
  
    close() {
      this.classList.remove('active');
      removeTrapFocus();
      document.body.classList.remove('overflow-hidden');
    }
  
    renderContents(html) {
      if (!this.container) return;
  
      this.container.innerHTML = html;
  
      setTimeout(() => {
        if (this.classList.contains('active')) return;
  
        this.querySelector('#ConfiguratorDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });
    }
  
    getBundle() {
      return this.bundle;
    }
  
    updateBundle(key, value) {
      this.bundle[key] = value;
  
      return this.bundle;
    }
  }
  
  customElements.define('configurator-drawer', ConfiguratorDrawer);
  